<template>
  <section class="app-main">
    <router-view></router-view>
  </section>
</template>

<script>

export default {}

</script>

<style lang="less" scoped>
.app-main {
  width: 100%;
  position: relative;
  min-height: 100vh;
  // background: #d8d8da;
  padding-top: 60px;
}
</style>
